import React from 'react';

const CheckBox = (props) => {
  let errorMsg = '';

  if (props.error && props.error.length > 0) {
    errorMsg = props.error;
  }

  const handelOnChange = (e, id) => {
    if (props.onChange) {
      props.onChange(e);
    } else {
      if (e.target.checked) {
        props.onCheck(id);
      } else {
        props.onUncheck(id);
      }
    }
  };

  return (
    <div className={`checkbox-component custom-control custom-checkbox ${props.customClassName ? props.customClassName : ''}`}>
      <input
        type='checkbox'
        className={`custom-control-input ${props.className ? props.className : ''}`}
        checked={props.checked}
        id={props.id}
        name={props.name}
        onChange={(e) => {
          handelOnChange(e, props.id);
        }}
      />
      <label className='custom-control-label' htmlFor={props.id}>
        {props.label ?? null}
        {props.children}
      </label>
      {errorMsg.length > 0 && <div className='error'>{errorMsg}</div>}
    </div>
  );
};

export default CheckBox;
